import { LowercaseLanguageCode } from '../../constants/Enums';

export const getSchemaOrgOrganization = ({ seo }) => ({
  '@context': 'http://schema.org',
  '@type': 'Organization',
  url: `https://www.wooclap.com${
    seo.lang !== LowercaseLanguageCode.EN ? `/${seo.lang}/` : '/'
  }`,
  logo: 'https://www.wooclap.com/images/logo/logo-blue.png',
  sameAs: [
    'https://www.facebook.com/wooclap',
    'https://twitter.com/wooclap',
    'https://www.linkedin.com/company/wooclapcompany/',
  ],
  address: {
    '@type': 'PostalAddress',
    addressCountry: 'BE',
    addressLocality: 'Brussels',
    postalCode: '1040',
    streetAddress: 'Rue des Pères Blancs, 4',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'info@wooclap.com',
    contactType: 'customer service',
    url: 'https://docs.wooclap.com/en/',
  },
  email: 'info@wooclap.com',
  founder: [
    {
      '@type': 'Person',
      givenName: 'Sébastien',
      familyName: 'Lebbe',
      jobTitle: 'CEO',
    },
    {
      '@type': 'Person',
      givenName: 'Jonathan',
      familyName: 'Alzetta',
      jobTitle: 'CTO',
    },
    {
      '@type': 'Person',
      givenName: 'Olivier',
      familyName: 'Verdin',
      jobTitle: 'Co-founder',
    },
  ],
  legalName: 'Wooclap SA',
  vatID: 'BE0563.691.645',
});
